import useInBodyApi from "@apis/useInBodyApi";
import { useEffect, useMemo, useState } from "react";

const useGetMeasureRecordsState = ({ isFetchOnMount = true, referenceID = 0, referenceType = 0 } = {}) => {
	const { getInterviewMeasureApi: doInterviewMeasureApi } = useInBodyApi();
	const [measureData, setMeasureData] = useState([]);

	// 取得量測紀錄
	const getInterviewMeasureApi = async () => {
		const resp = await doInterviewMeasureApi({ referenceID, type: referenceType });
		if (resp) {
			setMeasureData(resp.measureData || []);
		}
	};

	// 過濾有效的量測紀錄
	const validMeasureData = useMemo(() => measureData.filter(item => item.inbodyScore), [measureData]);

	useEffect(() => {
		let isMounted = true;
		if (isFetchOnMount && referenceID && referenceType) {
			(async () => {
				const resp = await doInterviewMeasureApi({ referenceID, type: referenceType });
				if (isMounted && resp) setMeasureData(resp.measureData || []);
			})();
		}
		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line
	}, [isFetchOnMount, referenceID, referenceType]);

	return { measureData, validMeasureData, getInterviewMeasureApi };
};

export default useGetMeasureRecordsState;
